import Login from './Login.page'

export default Login;